import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Family } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { ModelSetupVM,BASE_URL, ComponentList, ServiceCycleVM, Industry,ComponentType, ModelBaseObservations, PartlineModel, ChainInfoModel, ChainDescriptionModel, ChainActivePartModel, ChainActivePartVM, DealershipsCustomers, PartConfiqQuoteBillingDetails, UserDealerGroup, UserDealerGroupDealerships, UserQuoteHistory } from './setup-models.model';
@Injectable()
export class SetupModelsService {

  familyList: Family[];

  constructor(private _http: HttpClient) { }

  public getFamilyList(): Observable<Family[]> {
    return this._http.get<Family[]>(`${BASE_URL}/getFamilyList`).pipe(catchError(this.handleError));
  }

  public getServiceCycleList(): Observable<ServiceCycleVM[]> {
    return this._http.get<ServiceCycleVM[]>(`${BASE_URL}/getServiceCycleList`).pipe(catchError(this.handleError));
  }

  public getBaseModelList(typeid:number): Observable<ServiceCycleVM[]> {
    const options = {
      params: new HttpParams().set('TypeId', typeid.toString())
    };
    return this._http.get<ServiceCycleVM[]>(`${BASE_URL}/getBaseModelList`,options).pipe(catchError(this.handleError));
  }

  public getEquipIndustryist(): Observable<Industry[]> {
    return this._http.get<Industry[]>(`${BASE_URL}/getEqIndustryList`).pipe(catchError(this.handleError));
  }

  public getComponentTypeList(): Observable<ComponentType[]> {
    return this._http.get<ComponentType[]>(`${BASE_URL}/getComponetTypeList`).pipe(catchError(this.handleError));
  }
  public getModedlDetailsInfo(make_auto: number, model_auto: number,type_auto:number): Observable<ModelSetupVM[]> {
    let obj = {
      'make_auto': make_auto,
      'model_auto': model_auto,
      'type_auto': type_auto
    };
    return this._http
      .post<ModelSetupVM[]>(`${BASE_URL}/getModelInfoFillGrid`, obj).pipe(catchError(this.handleError));
  }

  public getComponentInfoByModelId(model_auto: number, chain_auto:number): Observable<ComponentList[]> {
    let obj = {
      'model_auto': model_auto,
      'chain_auto':chain_auto
    };
    return this._http.post<ComponentList[]>(`${BASE_URL}/getcompDetailsByModelId`, obj).pipe(catchError(this.handleError));
  }
  public GetPartLine(): Observable<PartlineModel[]> {
    return this._http.get<PartlineModel[]>(`${BASE_URL}/GetPartLine`).pipe(catchError(this.handleError));
  }
  
  public saveSetupchainDetail(
    model_auto:number,
    chainDescription:string,
    serialNumberEnd:string,
    serialNumberstart:string,
     pitch:number,
     noOfLinks:number,
     linkHeight:number,
     numberOfIdlers:number,
     boltHoleDiameter:number,
     bushingOD:number,
     numberOfCarrierRollers:number,
     numberOfTrackRollers:number,
     chainInsideSpread:string,
    chainOutsideSpread:string,
    ChainAutoId:number
    ): Observable<number> {
let obj = {
             'Modelauto' :model_auto,
             'Description' :chainDescription,
             'ModelSerialNumberStart' :serialNumberstart,
             'ModelSerialNumberEnd' :serialNumberEnd,
             'NumberOfLinks' :noOfLinks,
             'NumberOfIdlers' :numberOfIdlers,
             'NumberOfCarrierRollers' :numberOfCarrierRollers,
             'NumberOfTrackRollers' :numberOfTrackRollers,
             'Pitch' :pitch,
             'BoltHoleDiameter' :boltHoleDiameter,
             'BushingOD' :bushingOD,
             'ChainInsideSpread' :chainInsideSpread,
             'ChainOutsideSpread' :chainOutsideSpread,
             'LinkHeight':linkHeight,
             'ChainAutoId':ChainAutoId
};
return this._http
  .post<number>(`${BASE_URL}/SaveUpdateChainInfo`, obj).pipe(catchError(this.handleError));
}
public GetChainInfo(model_auto:number): Observable<ChainInfoModel[]> {
  const options = {
    params: new HttpParams().set('ModelId', model_auto.toString())
  };
  return this._http.get<ChainInfoModel[]>(`${BASE_URL}/GetChainInfo`,options).pipe(catchError(this.handleError));
}
  public getObservationInfoByModelId(model_auto: number): Observable<ModelBaseObservations[]> {
    let obj = {
      'model_auto': model_auto
    };
    return this._http
      .post<ModelBaseObservations[]>(`${BASE_URL}/getObservationsByModelId`, obj).pipe(catchError(this.handleError));
  }

  // public EnableObservationsByModelId(model_auto: number): Observable<ModelBaseObservations[]> {
  //   let obj = {
  //     'model_auto': model_auto
  //   };
  //   return this._http
  //     .post<ModelBaseObservations[]>(`${BASE_URL}/EnableObservationsByModelId`, obj).pipe(catchError(this.handleError));
  // }
  UpdateModelObsInfo(newModel : ModelBaseObservations): Observable<boolean>{
    return this._http.post<boolean>(`${BASE_URL}/UpdateModelObsInfo`, newModel).pipe(catchError(this.handleError));    
  }


  public getMobileScreenDisplayOfObservationsModelOption(modelId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('ModelId', modelId.toString())
    };
    return this._http.get<number>('api/Component/GetMobileScreenDisplayOfObservationsModelOption', options).pipe(catchError(this.handleError));
  }

  public UpdateVisibilityOnObs(Id: number): Observable<ModelBaseObservations> {
    let obj = {
      'Id': Id
    };
    return this._http
      .post<ModelBaseObservations>(`${BASE_URL}/UpdateVisibilityOnObs`, obj).pipe(catchError(this.handleError));
  }
  public saveSetupModeltDetails(
         model_auto :number,
         make_auto :number,
         type_auto :number ,
         service_cycle_type_auto :number,
         equip_reg_industry_auto :number,
         modelid :string,
         modeldesc:string,
         created_date :string,
         created_user :string,
         modified_date :string,
         modified_user :string,
         ModelNote :string,
         ModelImage :string,
         uploadToMobile:boolean,
         BaseModelId :number,
          ModelImageLeft:string,
          ModelImageRight:string
         ): Observable<ModelSetupVM[]> {
    let obj = {
                  'model_auto' :model_auto,
                  'make_auto' :make_auto,
                  'type_auto' :type_auto,
                  'service_cycle_type_auto' :service_cycle_type_auto,
                  'equip_reg_industry_auto' :equip_reg_industry_auto,
                  'modelid' :modelid,
                  'modeldesc' :modeldesc,
                  'created_date' :created_date,
                  'created_user' :created_user,
                  'modified_date' :modified_date,
                  'modified_user' :modified_user,
                  'ModelNote' :ModelNote,
                  'ModelImage' :ModelImage,
                  'uploadToMobile' :uploadToMobile,
                  'BaseModelId' :BaseModelId,
                  'ModelImageLeft' :ModelImageLeft,
                  'ModelImageRight' :ModelImageRight


    };
  return this._http
       .post<ModelSetupVM[]>(`${BASE_URL}/SaveModelSetupDetails`, obj).pipe(catchError(this.handleError));
    }

public deleteSetupModel(model_auto:number):Observable<ModelSetupVM[]>{
let obj= {
  'model_auto':model_auto
};
return this._http
.post<ModelSetupVM[]>(`${BASE_URL}/DeleteModelSetupDetails`, obj).pipe(catchError(this.handleError));
}


  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  
  public EnableObservationsByModelId(model_auto: number): Observable<ModelBaseObservations[]> {
    let obj = {
      'model_auto': model_auto
    };
    return this._http
      .post<ModelBaseObservations[]>(`${BASE_URL}/EnableObservationsByModelId`, obj).pipe(catchError(this.handleError));
  }

  public setMobileScreenDisplayOfObservationsModelOption(modelId: number, obsOption: number) {
    const options = {
      params: new HttpParams().set('ModelId', modelId.toString()).set('ObsOption', obsOption.toString())
    };
    return this._http.get('api/Component/SetMobileScreenDisplayOfObservationsModelOption', options).pipe(catchError(this.handleError));
  }



public GetChainDetailFiltered(modelid:number,makeid: number, serialNumber:string): Observable<ChainDescriptionModel[]> {
 
  const options = {
    params: new HttpParams().set('makeid', makeid.toString()).set('modelid', modelid.toString()).set('serialnumber', serialNumber.toString())
  };
  return this._http.get<ChainDescriptionModel[]>(`${BASE_URL}/GetChainDetailFiltered`,options).pipe(catchError(this.handleError));
}


 
 public GetUserDealerGroup(): Observable<UserDealerGroup[]> {
   
   return this._http.get<UserDealerGroup[]>(`api/Admin/GetUserDealerGroup`).pipe(catchError(this.handleError));
 }
 
 public GetUserDealerGroupDealerships(dealerGroupId: number): Observable<UserDealerGroupDealerships[]> {
   
   const options = {
     params: new HttpParams().set('dealerGroupId', dealerGroupId.toString())
   };
   return this._http.get<UserDealerGroupDealerships[]>(`api/Admin/GetUserDealerGroupDealerships`,options).pipe(catchError(this.handleError));
 }
 
 public GetDealerGroupDealershipsCustomers(dealershipid: number): Observable<DealershipsCustomers[]> {
   
   const options = {
     params: new HttpParams().set('dealershipId', dealershipid.toString())
   };
   return this._http.get<DealershipsCustomers[]>(`api/Admin/GetDealerGroupDealershipsCustomers`,options).pipe(catchError(this.handleError));
 }
 
 public SavePartConfiqQuote(DealerGroupId:number,DealershipId:number,
   CustomerId:number,FirstName:string,LastName:string,EmailId:string,ChainId:number,
   ContactNumber:number,BillingAddress:string,DeliveryAddress:string, fromConfirm:boolean
 ): Observable<number> {
 let obj = {
            'DealerGroupId' :DealerGroupId,
            'DealershipId' :DealershipId,
            'CustomerId' :CustomerId,
            'FirstName' :FirstName,
            'LastName' :LastName,
            'EmailId' :EmailId,
            'ChainId' :ChainId,
            'ContactNumber' :ContactNumber,
            'BillingAddress' :BillingAddress,
            'DeliveryAddress' :DeliveryAddress,
            'FromConfirm':fromConfirm
 };
 return this._http
 .post<number>(`api/Admin/SavePartConfiqQuote`, obj).pipe(catchError(this.handleError));
 }
 
 public GetPartConfiqQuote(chainId: number): Observable<PartConfiqQuoteBillingDetails> {
   
   const options = {
     params: new HttpParams().set('chainId', chainId.toString())
   };
   return this._http.get<PartConfiqQuoteBillingDetails>(`api/Admin/GetPartConfiqQuote`,options).pipe(catchError(this.handleError));
 }
 public SaveQuoteDetails(chainActivePartModel:ChainActivePartVM): Observable<number> {
   return this._http.post<number>(`api/Admin/SavePartConfiqQuoteDetail`,chainActivePartModel).pipe(catchError(this.handleError));
 }
 
 public getUserQuoteHistory(modelid:number): Observable<UserQuoteHistory[]> {
  const options = {
    params: new HttpParams().set('modelId', modelid.toString())
  };
   return this._http.get<UserQuoteHistory[]>(`api/Admin/GetUserQuoteHistory`,options).pipe(catchError(this.handleError));
 }
 public QuoteCommentUpdate(partQuoteId:number,quoteComment:string): Observable<number> {
   const options = {
     params: new HttpParams().set('partQuoteId', partQuoteId.toString()).set('quoteComment', quoteComment.toString())
   };
   return this._http.get<number>(`api/Admin/QuoteCommentUpdate`,options).pipe(catchError(this.handleError));
 }
 
 public EmailQuoteDetails(quoteComment:string,partquoteId:number, date:Date): Observable<number> {
   const options = {
     params: new HttpParams()
     .set('quoteComment', quoteComment.toString())
     .set('partquoteId', partquoteId.toString())
     .set('date', date.toString())
   };
   return this._http.get<number>(`api/SetupEquipment/EmailQuoteDetails`,options).pipe(catchError(this.handleError));
 }
 
 public GetPartQuoteComment(partquoteId:number): Observable<string> {
   const options = {
     params: new HttpParams().set('partquoteId', partquoteId.toString())
   };
   return this._http.get<string>(`api/SetupModel/GetPartQuoteComment`,options).pipe(catchError(this.handleError));
 }

 public GetChainActiveParts(model_auto: number, chain_auto:number,partquoteId:number,date:string): Observable<ChainActivePartModel[]> {
  if(partquoteId==null)
    partquoteId=0;
 
  const options = {
    params: new HttpParams().set('modelid', model_auto.toString())
    .set('chainId', chain_auto.toString())
    .set('partQuoteId', partquoteId.toString())
    .set('date', date.toString())
  };
  return this._http.get<ChainActivePartModel[]>(`${BASE_URL}/GetChainActiveParts`, options).pipe(catchError(this.handleError));
}


public PartsQuotesDetail(partquoteId:number, date:Date): Observable<Blob> {
  const options = {
    params: new HttpParams()
    .set('partquoteId', partquoteId.toString())
    .set('date', date.toString())
  };
  return this._http.get<Blob>(`api/SetupEquipment/GetPartQuotePdf`,options).pipe(catchError(this.handleError));
}
}
